/* eslint-disable react/style-prop-object */
import React, { useState, useEffect } from 'react';
import {
   Row, Col, Empty, Spin
} from 'antd';
import axios from 'axios';
import Utils from '../../../misc/Utils';
import {
   Chart as ChartJS,
   CategoryScale,
   LinearScale,
   BarElement,
   Title,
   Tooltip,
   Legend,
} from 'chart.js';
import { IntroSum } from '../components';
import DiagnosticReportUtils from '../../../misc/DiagnosticReportUtils';

export function MTG1RALSummaryReport(props) {
   const [reportData, setReportData] = useState(null);
   const [dataLoading, setDataLoading] = useState(false);

   const [phonological, setPhonological] = useState(null);
   const [phonics, setPhonics] = useState(null);
   const [vocabulary, setVocabulary] = useState(null);
   const [book, setBook] = useState(null);
   const [comprehending, setComprehending] = useState(null);
   const [creating, setCreating] = useState(null);
   const [total, setTotal] = useState(null);

   const [pcData, setPCData] = useState(null);
   // const [VN, setVN] = useState(null);

   var aid = props.assessment_id !== undefined ? props.assessment_id : props.assignment_id;

   useEffect(() => {
      Utils.verifyJwt();

      ChartJS.register(
         CategoryScale,
         LinearScale,
         BarElement,
         Title,
         Tooltip,
         Legend
      );

      getReport(aid, props.section_id);
   }, [aid]);

   const getReport = (assignment_id, section_id) => {
      setDataLoading(true);

      var url = "";

      if (props.version === 1)
         url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/getdiagnosticreportdata?aid=${assignment_id}&sid=${section_id}`;
      else
         url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/v2/getdiagnosticreportdata?aid=${assignment_id}&sids=${section_id}&s=${props.subject_id}&sy=${props.school_year}`;

      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;

            var preData = data.filter(item => item.diagnostic_type === 'pre');
            var postData = data.filter(item => item.diagnostic_type === 'post');
            // setVN(preData.length);

            if (props.version === 1)
               url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/getdiagnosticsummarypercentdata?aid=${assignment_id}&sid=${section_id}`;
            else
               url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/v2/getdiagnosticsummarypercentdata?aid=${assignment_id}&sids=${section_id}&s=${props.subject_id}&sy=${props.school_year}`;

            axios.get(url).then((response) => {

               if (response.data) {
                  const data2 = response.data;

                  setPCData(data2[0]);
                  extractData(preData, postData);

                  setReportData(data);
                  setDataLoading(false);
               }
            }, (error) => {
               console.log(error.message);
               setDataLoading(false);
            });
         }
      }, (error) => {
         console.log(error.message);
         setDataLoading(false);
      });
      // }
   }

   // Configuration for subject-specific data extraction
   const subjectConfigurations = {
      mtral: {
         categories: {
            phonological: { fields: Array.from({ length: 4 }, (_, i) => `s${i + 1}`), mean: 3.15, stdDev: 0.84, ranges: [[0, 2.72, 'Beginner'], [2.73, 3.57, 'Basic'], [3.58, 4, 'Competent']] },
            phonics: { fields: Array.from({ length: 4 }, (_, i) => `s${i + 5}`), mean: 2.86, stdDev: 1.06, ranges: [[0, 2.32, 'Beginner'], [2.33, 3.39, 'Basic'], [3.4, 4, 'Competent']] },
            vocabulary: { fields: Array.from({ length: 6 }, (_, i) => `s${i + 9}`), mean: 4.34, stdDev: 1.78, ranges: [[0, 3.44, 'Beginner'], [3.45, 5.23, 'Basic'], [5.24, 6, 'Competent']] },
            book: { fields: Array.from({ length: 4 }, (_, i) => `s${i + 15}`), mean: 1.46, stdDev: 1.09, ranges: [[0, 2.49, 'Beginner'], [2.5, 3.61, 'Basic'], [3.62, 4, 'Competent']] },
            comprehending: { fields: Array.from({ length: 14 }, (_, i) => `s${i + 19}`), mean: 1.46, stdDev: 1.09, ranges: [[0, 6.04, 'Beginner'], [6.05, 10.65, 'Basic'], [10.66, 14, 'Competent']] },
            creating: { fields: Array.from({ length: 3 }, (_, i) => `s${i + 33}`), mean: 1.46, stdDev: 1.09, ranges: [[0, 0.95, 'Beginner'], [0.96, 2.46, 'Basic'], [2.47, 3, 'Competent']] },
         },
         totalRanges: [[0, 19.01, 'Beginner'], [19.02, 29.94, 'Basic'], [29.95, 35, 'Competent']],
         setters: { total: setTotal, phonological: setPhonological, phonics: setPhonics, vocabulary: setVocabulary, book: setBook, comprehending: setComprehending, creating: setCreating },
      },
   };

   // Subject-specific wrappers for convenience
   const extractData = (pre_data, post_data) => Utils.extractDataForDiagnosticSummaryReport(props.diagnostic_type, pre_data, post_data, subjectConfigurations['mtral']);

   return (
      <>
         {
            dataLoading
               ?
               <div className='center-empty-space'>
                  <Spin size='large' tip="Loading data, please wait..." />
               </div>
               :
               (reportData !== null && reportData.length > 0)
                  ?
                  <div className="dashboard-item-inner3" style={{ margin: '20px' }}>
                     <div style={{ fontFamily: 'calibri' }} id='summary-report'>
                        <div>

                           <IntroSum
                              grade_level={props.template}
                              section={props.section_desc}
                              school_name={reportData[0].school_name}
                              subject_id={props.subject_id}
                              subject={props.subject}
                              backgroundColor="#4F81BD"
                              diagnostic_date={reportData[0].diagnostic_date}
                              diagnostic_type={props.diagnostic_type}
                           />

                           <p style={{ marginTop: '10pt', marginBottom: '0pt', lineHeight: '115%', fontSize: '12pt' }}>
                              <strong>&nbsp;</strong>
                           </p>
                           <div style={{ pageBreakBefore: 'always' }}></div>
                           <p style={{ textAlign: 'center', fontSize: '14pt' }}><strong>Summary of Results for {props.subject}</strong></p>
                           <p style={{ textAlign: 'center' }}><strong>{reportData[0].diagnostic_type === 'post' ? 'POST TEST' : 'PRE TEST'}</strong></p>
                           <p style={{ marginTop: '0pt', marginBottom: '0pt' }}><strong>MEAN LEVEL OF SCORES IN THE SUBJECT AREAS</strong></p>
                           <table style={{ width: '100%', border: '0.75pt solid #cccccc', borderCollapse: 'collapse' }}>
                              <tbody>
                                 <tr>
                                    <td style={{ textAlign: 'center', width: '25%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Area</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '4%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>N</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Pretest Mean</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Post Test Mean</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Min</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '11%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Max</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '14%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Standard Deviation</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '13%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Proficiency Level</span></strong>
                                    </td>
                                 </tr>
                                 {DiagnosticReportUtils.generateMeanLevelRow('Phonological awareness', phonological, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Phonics', phonics, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Vocabulary', vocabulary, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Book and Print knowledge', book, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Comprehending and Analyzing', comprehending, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Creating and composing text', creating, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('TOTAL', total, true)}
                              </tbody>
                           </table>
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>&nbsp;</strong></p>
                           <table style={{ width: '100%', border: '0.75pt solid #cccccc', borderCollapse: 'collapse' }}>
                              <tbody>
                                 <tr style={{ height: '14.5pt' }}>
                                    <td style={{ width: '39.3%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Content Standards</span></strong></p>
                                    </td>
                                    <td colSpan={3} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Beginner</span></strong></p>
                                    </td>
                                    <td colSpan={3} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Basic</span></strong></p>
                                    </td>
                                    <td colSpan={3} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Competent</span></strong></p>
                                    </td>
                                 </tr>
                                 {DiagnosticReportUtils.generateContentStandards('Phonological awareness', 0, 2.72, 2.73, 3.57, 3.58, 4)}
                                 {DiagnosticReportUtils.generateContentStandards('Phonics', 0, 2.32, 2.33, 3.39, 3.4, 4)}
                                 {DiagnosticReportUtils.generateContentStandards('Vocabulary', 0, 3.44, 3.45, 5.23, 5.24, 6)}
                                 {DiagnosticReportUtils.generateContentStandards('Book and Print knowledge', 0, 2.49, 2.5, 3.61, 3.62, 4)}
                                 {DiagnosticReportUtils.generateContentStandards('Comprehending and Analyzing', 0, 6.04, 6.05, 10.65, 10.66, 14)}
                                 {DiagnosticReportUtils.generateContentStandards('Creating and composing text', 0, 0.95, 0.96, 2.46, 2.47, 3)}
                                 {DiagnosticReportUtils.generateContentStandards('TOTAL', 0, 19.01, 19.02, 29.94, 29.95, 35)}
                              </tbody>
                           </table>
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>&nbsp;</strong></p>
                           {DiagnosticReportUtils.generateMTFrequencyRow('Phonological awareness', phonological, 1)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Phonics', phonics, 2)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Vocabulary', vocabulary, 3)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Book and Print knowledge', book, 4)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Comprehending and Analyzing', comprehending, 5)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Creating and composing text', creating, 6)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('TOTAL', total, 5)}
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>&nbsp;</strong></p>
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>Percent of Correct</strong></p>
                           <table style={{ width: '100%', border: '0.75pt solid #cccccc', borderCollapse: 'collapse' }}>
                              <tbody>
                                 <tr>
                                    <td colSpan={2} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center' }}><strong><span style={{ color: '#ffffff' }}>LEARNING COMPETENCY</span></strong></p>
                                    </td>
                                    <td style={{ width: '19.9%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center' }}><strong><span style={{ color: '#ffffff' }}>Pre Test Percent Correct for the Level</span></strong></p>
                                    </td>
                                    <td style={{ width: '20.6%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center' }}><strong><span style={{ color: '#ffffff' }}>Post Test Percent Correct for the Level</span></strong></p>
                                    </td>
                                 </tr>

                                 {DiagnosticReportUtils.renderLabel("Part 1: Phonological Awareness")}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify rhyming words in nursery rhymes, poems, and chants.", pcData, 1)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify rhyming words in nursery rhymes, poems, and chants.", pcData, 2)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify initial sounds (vowels, consonants, and semi-vowels, if any).", pcData, 3)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify initial sounds (vowels, consonants, and semi-vowels, if any).", pcData, 4)}
                                 {DiagnosticReportUtils.renderLabel("Part 2: Phonics")}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify the letters in L1.", pcData, 5)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify the letters in L1.", pcData, 6)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Isolate sounds (consonants and vowels) in a word (beginning and/or ending).", pcData, 7)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Isolate sounds (consonants and vowels) in a word (beginning and/or ending).", pcData, 8)}
                                 {DiagnosticReportUtils.renderLabel("Part 3: Vocabulary")}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Use vocabulary referring to oneself and family.", pcData, 9)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Use vocabulary referring to oneself and family.", pcData, 10)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify words with different functions (naming and describing words): words that label persons, places, things, animals, actions, situations, ideas, and emotions.", pcData, 11)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify words with different functions (naming and describing words): words that label persons, places, things, animals, actions, situations, ideas, and emotions.", pcData, 12)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Read content-specific words (Math, SiKaP, GMRC) accurately for meaning.", pcData, 13)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Read content-specific words (Math, SiKaP, GMRC) accurately for meaning.", pcData, 14)}
                                 {DiagnosticReportUtils.renderLabel("Part 4: Book and Print Knowledge")}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Recognize environmental print (symbols).", pcData, 15)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Recognize environmental print (symbols).", pcData, 16)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Recognize the parts of the book (cover page, title page, etc.).", pcData, 17)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Recognize the parts of the book (cover page, title page, etc.).", pcData, 18)}
                                 {DiagnosticReportUtils.renderLabel("Part 5: Comprehending and Analyzing")}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Note important details in stories (character, setting,).", pcData, 19)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Note important details in stories (events).", pcData, 20)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Sequence stories with at least 3 even.", pcData, 21)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Infer the character’s feelings and traits.", pcData, 22)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Predict possible ending.", pcData, 23)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Note important details in stories (character, setting,).", pcData, 24)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Note important details in stories (events).", pcData, 25)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Note important details in stories (events).", pcData, 26)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Infer the character’s feelings and traits.", pcData, 27)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Predict possible ending.", pcData, 28)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Note significant details in informational texts (list and describe).", pcData, 29)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify problem and solution.", pcData, 30)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Note significant details in informational texts (list and describe).", pcData, 31)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Identify problem and solution.", pcData, 32)}
                                 {DiagnosticReportUtils.renderLabel("Part 6: Creating and Composing Text")}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Narrate one’s personal experiences:  (a) oneself and family.", pcData, 33)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Narrate one’s personal experiences:  (b) content-specific topics.", pcData, 34)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow2("Use own words in retelling myths, legends, fables, and narrative poems.", pcData, 35)}

                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div >
                  :
                  <div className='center-empty-space'>
                     <Empty
                        description='No Data Found'
                        image="../images/brainee_mascot.png"
                     />
                  </div>
         }

      </>
   );
}